import { mapState, mapMutations } from 'vuex'
import ServiceDeliveryTypeSelectorButton from '@/components/Ui/ServiceDeliveryTypeSelectorButton'
import ServiceRssSelectorButton from '@/components/Ui/ServiceRssSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ListButtonItem',
  components: {
    ServiceDeliveryTypeSelectorButton,
    ServiceRssSelectorButton,
  },
  props: {
    index: Number
  },
  data () {
    return {
      inited: false,

      // input
      input: {
        uuid: null,
        listType: '',
        serviceRssUUIDs: [],
        noticeDeliveryType: [],
        noticeDeliveryAttribute: '',
        badgeColor: null,
        badgeText: null
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // form
      serviceId: state => state.serviceScreenSettingForm.serviceId,
      serviceContentsId: state => state.serviceScreenSettingForm.targetId,
      contentsScreenId: state => state.serviceScreenSettingForm.targetId,
      values: state => state.serviceScreenSettingForm.values,

      // model
      serviceRssModel: state => state.serviceScreenSettingForm.serviceRssModel,
    }),

    // list
    listTypeList () {
      return Constants.ScreenSetting.ListType
    },
    deliveryAttributeList () {
      return Constants.ScreenSetting.NoticeDeliveryAttribute
    },

    // validate
    formIsValid () {
      const v1 = this.validate('listType')
      if (!v1) return false

      let v2 = false
      switch (this.input.listType) {
        // お知らせ
        case 1:
          v2 = this.validate('noticeDeliveryType') &&
            this.validate('noticeDeliveryAttribute')
          break
        // RSS
        case 2:
          v2 = this.validate('serviceRssUUIDs')
          break
      }
      if (!v2) return false

      const v3 = this.validate('badgeColor') &&
        this.validate('badgeText')
      if (!v3) return false

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        uuid: this.input.uuid,
        listType: this.input.listType
      }

      // お知らせ
      if (jsonb.listType === 1) {
        jsonb.noticeDeliveryType = this.input.noticeDeliveryType
        jsonb.noticeDeliveryAttribute = this.input.noticeDeliveryAttribute
      }
      // RSS
      if (jsonb.listType === 2) {
        jsonb.serviceRssUUIDs = this.input.serviceRssUUIDs
      }

      // バッジ設定
      if (Validator.validText(this.input.badgeColor)) {
        jsonb.badgeColor = this.input.badgeColor
      }
      if (Validator.validText(this.input.badgeText)) {
        jsonb.badgeText = this.input.badgeText
      }

      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        console.log(this.getJsonb)
        this.setValidate({
          key: 'listButton',
          index: this.index,
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'serviceScreenSettingForm/setValidate'
    }),

    init () {
      let data = $.extend(true, this.input, this.values.screenListBtnSettings[this.index])

      // バッジ設定で設定済のRSS設定が削除されていた場合、入力値から削除する
      // console.log('@@data', data.serviceRssUUIDs);
      // console.log('@@serviceRssModel', this.serviceRssModel)
      const fixedRssList = data.serviceRssUUIDs
        .filter(uuid => this.serviceRssModel.findIndex(item => item.serviceRssUuid === uuid) !== -1)
      // console.log('@@fixedRssList', fixedRssList)
      data.serviceRssUUIDs = fixedRssList

      this.$set(this, 'input', data)

      this.$nextTick(() => {
        this.inited = true
      })
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },

    /**
     * DeliveryType設定の変更
     */
    changeDeliveryTypeValue (props) {
      console.log('changeDeliveryTypeValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },

    /**
     * Rss設定の変更
     */
    changeRssValue (props) {
      console.log('changeRssValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },

    validate (key) {
      switch (key) {
        case 'listType':
        case 'noticeDeliveryAttribute':
          return Validator.validSelect(this.input[key])
        case 'noticeDeliveryType':
        case 'serviceRssUUIDs':
          return Validator.validArray(this.input[key])
        case 'badgeColor':
        case 'badgeText':
          return Validator.validText(this.input[key])
      }
    },
  }
}
